const Header = () => {
  return (
    <header>
                <nav>
                    <div className="logo">
                        <img src="imagenes/logo naranja.png" alt="Logo Herrería Vader" />
                    </div>
                    <ul>
                        <li><a href="#inicio">Inicio</a></li>
                        <li><a href="#servicios">Servicios</a></li>
                        <li><a href="#galeria">Trabajos</a></li>
                        <li><a href="#contacto-form">Contacto</a></li>
                    </ul>
                </nav>
            </header>
  );
};
export default Header;